import React from 'react';
import { Empty, Spin } from 'antd';
import { isNil } from 'lodash';
import { SelectProps } from 'antd/lib/select';
import { deepForEach } from 'react-children-utilities';

import { enableVirtualScrollItemsCount } from 'constants/AntdConfig';

interface OptionsProps {
  label: string;
  value: string;
}

interface Props {
  isLoading?: boolean;
  notFoundContent?: React.ReactNode;
  options?: SelectProps<OptionsProps>;
  children: React.ReactNode | React.ReactNode[];
}

const getChildrenCount = (nodes: React.ReactNode | React.ReactNode[]) => {
  let count = 0;

  deepForEach(nodes, () => count++);

  return count;
};

function WithLoading<T extends object>(BaseComponent: React.ComponentType<T>) {
  return ({ ...props }: T & Props) => {
    const { isLoading, notFoundContent, options, children, ...otherProps } =
      props;

    const renderNotFoundContent = () => {
      if (isLoading) return <Spin size="small" />;

      if (isNil(options)) return;

      return notFoundContent ? (
        notFoundContent
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      );
    };

    const isVirtualScroll =
      (Array.isArray(options) &&
        options.length >= enableVirtualScrollItemsCount) ||
      getChildrenCount(children) >= enableVirtualScrollItemsCount;

    return (
      <BaseComponent
        {...(otherProps as T)}
        children={children}
        virtual={isVirtualScroll}
        options={options}
        notFoundContent={renderNotFoundContent()}
      />
    );
  };
}

export default WithLoading;
